import mapApi from '../../api/map';
import * as types from '../mutation-types';
import { NOT_INCLUDED_INDEX } from '../constants';

const initialState = {
  creatingPurchase: false,
  exchangingPurchase: false,
  projects: [],
  randomDistProjects: [],
};

const actions = {
  checkEmailVacancies(_, { brandId, projectId, email }) {
    return mapApi.getEmailVacancies({ brandId, projectId, email }).then(res => res.emailVacancies,
      (err) => err);
  },
  checkEmailForCampaign(_, { campaignId, email }) {
    return mapApi.checkEmailForCampaign({ campaignId, email }).then(res => res.availability,
      (err) => err);
  },
  createsPurchaseWithPlot({ commit }, {
    projectId,
    name,
    email,
    uploadIdentifier,
    plotSize,
    entityType,
    entitySlug,
    pictureId,
  }) {
    const mapPath = `/${entityType}/${entitySlug}`;
    commit(types.CREATING_PURCHASE, true);

    return mapApi
      .createPurchase({ projectId, name, email, uploadIdentifier, plotSize, mapPath, pictureId })
      .then(response => {
        commit(types.CREATING_PURCHASE, false);

        return response;
      })
      .catch(err => {
        commit(types.CREATING_PURCHASE, false);
        commit(types.SHOW_TOAST, `[ERROR] ${err.response.msg}. Please try again.`);
        const error = new Error(err.response.msg);
        error.errors = err.response.errors;
        throw error;
      });
  },
  exchangePurchase({ commit }, {
    projectId,
    name,
    email,
    uploadIdentifier,
    campaignId,
    couponId,
    entityType,
    entitySlug,
    pictureId,
  }) {
    const mapPath = `/${entityType}/${entitySlug}`;
    commit(types.EXCHANGING_PURCHASE, true);

    return mapApi
      .createPurchase({
        projectId, name, email, uploadIdentifier, campaignId, couponId, mapPath, pictureId,
      })
      .then(response => {
        commit(types.EXCHANGING_PURCHASE, false);

        return response;
      })
      .catch(err => {
        commit(types.EXCHANGING_PURCHASE, false);
        commit(types.SHOW_TOAST, `[ERROR] ${err.response.msg}. Please try again.`);
        const error = new Error(err.response.msg);
        error.errors = err.response.errors;
        throw error;
      });
  },
  initProjectsProfile({ commit }, { brandId }) {
    mapApi
      .getProjects({ brandId, projectType: 'park', onlyWithActivePicAreas: 'true' })
      .then(projects => {
        commit(types.SET_RANDOM_DIST_PROJECTS, projects);

        return projects;
      })
      .catch(err => {
        commit(types.SHOW_TOAST, `[ERROR] ${err.response.msg}. Please try again.`);
        const error = new Error(err.response.msg);
        error.errors = err.response.errors;
        throw error;
      });

    mapApi
      .getProjects({ projectType: 'park', onlyWithActivePicAreas: 'true' })
      .then(projects => {
        commit(types.SET_PROJECTS, projects);

        return projects;
      })
      .catch(err => {
        commit(types.SHOW_TOAST, `[ERROR] ${err.response.msg}. Please try again.`);
        const error = new Error(err.response.msg);
        error.errors = err.response.errors;
        throw error;
      });
  },
};

const mutations = {
  [types.CREATING_PURCHASE](state, payload) {
    state.creatingPurchase = payload;
  },
  [types.EXCHANGING_PURCHASE](state, payload) {
    state.exchangingPurchase = payload;
  },
  [types.SET_PROJECTS](state, payload) {
    state.projects = payload;
  },
  [types.SET_RANDOM_DIST_PROJECTS](state, payload) {
    state.randomDistProjects = payload;
  },
};

const getters = {
  projects: (state) => (projectIds) => {
    if (projectIds !== null) {
      return state.projects.filter(p => projectIds.indexOf(p.id) !== NOT_INCLUDED_INDEX);
    }

    return state.projects;
  },
  project: (state) => (projectId) =>
    state.projects.find(p => projectId === p.id),
  randomDistProjects: (state) => (projectIds) => {
    if (projectIds !== null) {
      return state.randomDistProjects.filter(p => projectIds.indexOf(p.id) !== NOT_INCLUDED_INDEX);
    }

    return state.randomDistProjects;
  },
};

export default {
  state: initialState,
  actions,
  mutations,
  getters,
};
